import * as React from "react";
import styled from "styled-components";
import { select } from "@hubper/theme";

type ColumnProps = {
  style?: React.CSSProperties;
  className?: string;
  children?: any;
  grow?: number;
};

type ColumnPropsExtra = {
  spacing?: number;
  grow?: number;
};

const ColumnBase = styled.div<ColumnPropsExtra>`
  position: relative;
  flex: 1 0;
  flex-grow: ${p => p.grow && p.grow};

  &:not(:last-child) {
    margin-right: ${p => select.space(p.spacing)};
  }
`;

const Column = (
  { style, className, children, spacing, grow }: ColumnProps & ColumnPropsExtra,
  ref: any
) => {
  return (
    <ColumnBase
      className={className}
      style={style}
      spacing={spacing}
      grow={grow}
      ref={ref}
    >
      {children}
    </ColumnBase>
  );
};

const ColumnsBase = styled.div`
  display: flex;
  justify-content: flex-start;
`;

type Props = {
  style?: React.CSSProperties;
  className?: string;
  children: any;
  spacing: number;
};

const Columns = React.forwardRef(function Columns(
  { style, className, children, spacing }: Props,
  ref: any
) {
  if (typeof spacing === "string") {
    spacing = parseInt(spacing, 10);
  }

  return (
    <ColumnsBase ref={ref} style={style} className={className}>
      {React.Children.map(children, child => {
        const { props } = child;
        return React.cloneElement(child, {
          ...props,
          spacing
        });
      })}
    </ColumnsBase>
  );
}) as React.ComponentType<Props> & {
  Column?: React.ComponentType<ColumnProps & ColumnPropsExtra>;
};

Columns.Column = React.forwardRef(Column);

export default Columns;
